import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  onRenderColumnStack: {
    height: 25,
  },
}));
